import { Routes, Route, useLocation } from "react-router-dom"; // routes =mapping a URL path to a component, route=replaces switch cases
import Layout from "./components/layout/layout";
import NotificationDropdown from "./components/notifications/notificationDropdown";
import LandingPage from "./pages/landing/landing";
import Skits from "./pages/skitsLists/skitsListPage";
import SkitURL from "./pages/skitsUrl/skitsUrl";
import UsersWhoVotedListingPage from "./pages/usersWhoVotedListingPage/usersWhoVotedListingPage";
import TermsAndConditions from "./pages/rewardPointTerms/termsAndConditions";
import TopSkitsListsPage from "./pages/topSkistLists/topSkistListsPage";
import UserProfilePage from "./pages/profile/userProfilePage";
import SubscribersListPage from "./pages/subscriptionsPage/subscriberListPage";
import SubscriptionListPage from "./pages/subscriptionsPage/subscriptionListPage";
import InfoPage from "./pages/information/infoPage";
import CurrentUserSkitDashboard from "./pages/skitDashboard/skitDashboard";
import CurrentUserAdsManagerDashboard from "./pages/adsManagerDashboard/adsManagerDashboard";
import SearchAccountsPage from "./pages/searchAccountsPage/searchAccountsPage";
import TransactionHistoryPage from "./pages/transactionHistoryPage/transactionHistoryPage";
import WalletPage from "./pages/wallet/walletPage";
import AdminDashboard from "./pages/adminDashboard/adminDashboard";
import BrandAmbassadorDashboard from "./pages/brandAmbassadorDashboard/brandAmbassadorDashboard";
import StandingMetricsContract from "./pages/brandAmbassadorDashboard/standingMetricsContract";
import OffersList from "./pages/offersListing/offersListing";
import Schedule from "./pages/schedule/schedule";
import AccountsReceivables from "./pages/accountsReceivablesDashboard/accountsReceivables";
import TermsOfService from "./pages/staffTermsConditionsAgreement/terms-of-service";
import Top100Skits from "./pages/top100Skits/top100Skits";
import FieldLeaderDashboard from "./pages/fieldLeaderDashboard/fieldLeaderDashboard";
import WhistleBlownSkitPage from "./pages/whistleBlown/whistleBlownSkitPage";
import WhistleBlownCommentPage from "./pages/whistleBlown/whistleBlownCommentPage";
import CfoDashboard from "./pages/cFoDashboard/cFoDashboard";
import FinanceLogin from "./components/forms/financeReportingLogin/financeReportingLogin";
import InvestorDashboard from "./pages/investorDashboard/investorDashboard";
import AccountsPayable from "./pages/accountsPayableDashboard/accountsPayable";
import WagesPayable from "./pages/accountsPayableDashboard/wagesPayable";
import UniversalSearchPage from "./pages/universalSearchPage/universalSearchPage";
import UploadSkitStepPage from "./pages/uploadSkitStepPage/uploadSkitStepPage";
import MembersStatusPage from "./pages/membersStatusPage/membersStatusPage";
import TournamentControlPanelPage from "./pages/tournamentControlPanelPage/tournamentControlPanelPage";
import "./index.scss"; // Global styles for color is also in this file
import "./styles/blinkingCursors.scss";
import "./styles/sharedGlobalStyles.scss";

const App = () => {
  const location = useLocation();
  let showNotificationBell = false;

  // Explicitly check which paths should show the notification bell

  // Expression: location.pathname is the expression being evaluated in the switch statement.
  // It contains the current URL path, such as /, /home, /about, etc.

  // Case "/": If location.pathname is / (the root path), the case "/" block runs.
  // Here, showNotificationBell is set to false (no notification bell for the landing page).
  // Default:

  // If location.pathname does not match any case value, the default block runs.
  // This sets showNotificationBell to true for all other routes.

  switch (location.pathname) {
    case "/":
      // Landing Page - No bell
      showNotificationBell = false;
      break;
    default:
      // All other routes - Show bell
      showNotificationBell = true;
      break;
  }

  return (
    <>
      {/* Notification Dropdown, Wrapped the app with the NotificationDropdown component in the index.js and setting it outside the Routes component, so it renders consistently across all routes.
       */}
      {/* Render the Notification Bell based on the logic */}
      {showNotificationBell && <NotificationDropdown />}
      {/* Routes */}
      <Routes>
        {/* ← Stand-alone reports routes (no Layout wrapper) */}
        <Route path="reports" element={<FinanceLogin />} />
        <Route path="reports/cfo" element={<CfoDashboard />} />
        <Route path="reports/investor" element={<InvestorDashboard />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<LandingPage />} />
          <Route path="upload-skit" element={<UploadSkitStepPage />} />
          <Route exact path="skitslist" element={<Skits />} />
          <Route path="skit/:skitId" element={<SkitURL />} />
          <Route
            path="members-status-page/:userId"
            element={<MembersStatusPage />}
          />
          <Route
            path="skit/:skitId/ratings"
            element={<UsersWhoVotedListingPage />}
          />
          <Route path="top-skits" element={<TopSkitsListsPage />} />
          <Route path="user-profile/:userId" element={<UserProfilePage />} />
          <Route
            path="user/:userId/subscribers"
            element={<SubscribersListPage />}
          />
          <Route path="user/subscribers" element={<SubscriptionListPage />} />
          <Route path="information" element={<InfoPage />} />
          <Route
            path="user-profile/:userId/skit-dashboard"
            element={<CurrentUserSkitDashboard />}
          />
          <Route
            path="user-profile/:userId/ads-dashboard"
            element={<CurrentUserAdsManagerDashboard />}
          />
          <Route path="search-accounts" element={<SearchAccountsPage />} />
          <Route
            path="universal-search"
            element={<UniversalSearchPage initialQuery="" />}
          />
          <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          <Route
            path="user/:userId/transactionHistoryPage"
            element={<TransactionHistoryPage />}
          />
          <Route path="user/:sourceId/walletPage" element={<WalletPage />} />
          <Route
            path="user-profile/:userId/admin-dashboard"
            element={<AdminDashboard />}
          />
          <Route
            path="user-profile/:userId/ambassador-dashboard"
            element={<BrandAmbassadorDashboard />}
          />
          <Route
            path="user-profile/:userId/field-leader-dashboard"
            element={<FieldLeaderDashboard />}
          />
          <Route
            path="user-profile/:userId/tournament-control-panel"
            element={<TournamentControlPanelPage />}
          />
          <Route
            path="ambassador-dashboard/:userId/standing-metrics"
            element={<StandingMetricsContract />}
          />
          <Route path="staff/:userId/schedule" element={<Schedule />} />
          <Route
            path="offers-schedule-lists/:userId/offers"
            element={<OffersList />}
          />
          <Route
            path="accounts-receivables-dashboard/:userId/accounts-receivables"
            element={<AccountsReceivables />}
          />
          <Route
            path="/accounts-payable-dashboard/:userId/accounts-payable"
            element={<AccountsPayable />}
          />
          <Route
            path="/accounts-payable-dashboard/:userId/wages-payable"
            element={<WagesPayable />}
          />
          <Route path="terms-of-service" element={<TermsOfService />} />
          <Route
            path="top-100-skits/:userId/top-100-skits-billboard"
            element={<Top100Skits />}
          />
          <Route
            path="admin-dashboard/:userId/whistle-blown-skit-page"
            element={<WhistleBlownSkitPage />}
          />
          <Route
            path="admin-dashboard/:userId/whistle-blown-comment-page"
            element={<WhistleBlownCommentPage />}
          />
          <Route path="kpi" element={<CfoDashboard />} />
        </Route>
      </Routes>
    </>
  );
};
export default App;

{
  /* This is your new route */
}
{
  /* if user is not authenticated then user is redirected to the landing page
        {/* <Route
          path="skitslist"
          element={isAuthenticated() ? <Skits /> : <Navigate to="/" replace />}
        />
        <Route
          path="/skit/:skitId"
          element={
            isAuthenticated() ? <SkitURL /> : <Navigate to="/" replace />
          }
        />
        <Route
          path="/skit/:skitId/ratings"
          element={
            isAuthenticated() ? (
              <UsersWhoVotedListingPage />
            ) : (
              <Navigate to="/" replace />
            )
          }
        /> */
}

// Why Use Lazy Loading?
// Performance Improvement: Particularly beneficial for
// larger applications with many components. It reduces the
// initial load time by splitting the bundle into smaller chunks
// and only loading them when needed.
// Bandwidth Conservation: Useful in bandwidth-constrained
// scenarios, as it minimizes the amount of data transferred until it is necessary.
// User Experience: Enhances user experience by speeding up the initial
// page load, which can help retain users who might leave a site that takes too long to load.
